import React, { useEffect, useState } from 'react';
import { Link, useHistory, useParams } from 'react-router-dom';
import { Col, Divider, notification, Row, Spin } from 'antd';
import axios from 'axios';
import MarkdownContent from '../../common/MarkdownContent';
import { Helmet } from 'react-helmet';
import '../assets/css/article.css';
import eye from '../assets/images/grey-eye.svg';

export default function ViewArticle({
  categoryArticles,
  setDetailsPage,
  category,
}) {
  const history = useHistory();
  const [loading, setLoading] = useState(true);
  const [articleId, setArticleId] = useState(useParams()['article_id']);
  const [articleData, setArticleData] = useState(null);

  const updatedArticles = categoryArticles?.filter(
    (item) => item.id !== articleId
  );

  const getArticles = () => {
    const axios_config = {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      withCredentials: true,
      params: { id: articleId },
    };

    axios
      .get('social/blog', axios_config)
      .then((res) => {
        if (res.status === 200) {
          let result = res.data.result;
          setArticleData(result);
          setLoading(false);
        } else {
          notification.error({
            message: <div className='gSemiBold'>There was an issue!</div>,
            style: { border: '1px #D34545 solid' },
            placement: window?.innerWidth <= 500 ? 'bottom' : 'topRight',
            className: 'gRegular br10',
            description: 'Error processing request',
          });
        }
      })
      .catch((err) => {
        if (err.response.status === 404) {
          history.replace('/404');
        }
        notification.error({
          message: <div className='gSemiBold'>There was an issue!</div>,
          style: { border: '1px #D34545 solid' },
          placement: window?.innerWidth <= 500 ? 'bottom' : 'topRight',
          className: 'gRegular br10',
          description: 'Error processing request',
        });
      })
      .finally(() => {});
  };
  let paramsId = useParams()['article_id'];
  useEffect(() => {
    getArticles();
  }, [articleId]);
  useEffect(() => {
    if (!paramsId) {
      setDetailsPage(false);
    }
  }, [paramsId]);

  return (
    <>
      {loading ? (
        <div className='full-page-loading-icon'>
          <Spin />
        </div>
      ) : (
        <>
          <Helmet>
            <meta charSet='utf-8' />
            <meta name='description' content='Swimbooker' />
            <title>{articleData.title} | swimbooker</title>
          </Helmet>
          <Row>
            <Col className='gutter-row mg-bottom-30' span={24}>
              <div
                id='article-page-cover-image'
                style={{ backgroundImage: `url(${articleData.image})` }}
              />
            </Col>
          </Row>
          <div
            className='fs-40 gBold'
            style={{ color: 'rgba(23, 74, 115, 0.96)' }}
          >
            {articleData?.title}
          </div>
          <div className='gLight fs-24 mg-bottom-5'>
            Written by <span className='gSemiBold'>{articleData?.author}</span>
          </div>
          <div className='gSemiBold grey-500 fs-20 row-center'>
            <img src={eye} alt='eye' className='mg-right-15' />
            {articleData?.read_time_mins}{' '}
            {articleData?.read_time_mins > 1 ? 'mins' : 'min'}
          </div>
          <Divider style={{ borderTop: '2px solid #D9EEFF' }} />
          <Row>
            <Col className='gutter-row ' span={24}>
              <div id='article-markdown-content'>
                <MarkdownContent
                  content={articleData.content}
                  className='article-markdown'
                />
                <div
                  className='back-to-category-button gBold fs-18 cp '
                  onClick={() => {
                    setDetailsPage(false);
                    history.push('/articles');
                  }}
                >
                  Back to {category}
                </div>
                {updatedArticles?.length > 0 && (
                  <>
                    <div className='fs-36 gSemiBold mg-top-30 mg-bottom-50'>
                      Other Articles
                    </div>
                    <Row
                      gutter={[30, 20]}
                      className='article-summary-container '
                    >
                      {updatedArticles?.slice(0, 3).map((item, index) => {
                        return (
                          <Col
                            key={`article-${index}`}
                            xs={24}
                            md={12}
                            lg={8}
                            className='cp article-summary-wrapper'
                            onClick={() => {
                              setArticleId(item.id);
                            }}
                          >
                            <Link to={`/article/${item.id}`}>
                              <img
                                className='img'
                                src={item.image}
                                alt='article-image'
                              />
                              <div className='fs-20 gMedium grey-500 mg-bottom-15'>
                                {category}
                              </div>
                              <div className='fs-24 gBold text-heading  mg-bottom-15'>
                                {item?.title}
                              </div>
                              <div className='fs-20 gMedium  mg-bottom-15 preview-text'>
                                {item?.preview}
                              </div>
                              <div className='justify-between'>
                                <div className='fs-20 gSemiBold sb-black'>
                                  {item?.author}
                                </div>
                                <div className='fs-20 gSemiBold grey-500 row-center'>
                                  <img
                                    src={eye}
                                    alt='eye'
                                    className='mg-right-15'
                                  />
                                  <div className='row-center'>
                                    {item?.read_time_mins}{' '}
                                    {item?.read_time_mins > 1 ? 'mins' : 'min'}
                                  </div>
                                </div>
                              </div>
                            </Link>
                          </Col>
                        );
                      })}
                    </Row>
                  </>
                )}
              </div>
            </Col>
          </Row>
        </>
      )}
    </>
  );
}
